import { useState } from 'preact/hooks'
import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from 'libs/athos/hooks/useBeaconAnalytics'
import { ResultsCard } from 'libs/athos/components/ResultCard'
import { SkeletonCard } from 'libs/athos/components/SkeletonCard'
import clsx from 'clsx'

export function BaseResults({ className, containerClassName = 'flex relative w-full', wrapperClassName = '', productCardSettings, renderWrapper, placeholderCount, mobileSlider = false, beaconEnabled = true, CardComponent = ResultsCard, SkeletonComponent = SkeletonCard }) {
  const { results, isLoading } = useAthosContext()
  const [node, setNode] = useState()

  useBeaconLogRender({ enabled: beaconEnabled })
  useBeaconLogImpressions(node, { enabled: beaconEnabled })

  if (results?.results?.length === 0 && !isLoading) return null

  const count = results?.results?.length || placeholderCount || 8
  const items = Array.from({ length: count }, (_, index) => ({
    id: index,
    result: results?.results?.[index]
  }))

  const renderSkeletonItems = () => items.map((_, index) => (
    <div className={clsx(className, 'shrink-0')} key={`skeleton-${index}`}>
      <SkeletonComponent {...(productCardSettings && { options: productCardSettings })} />
    </div>
  ))

  const renderRealItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result && (
        <CardComponent
          result={result}
          className="wk-wishlist-button-target"
          dataIndex={id.toString()}
          mobileSlider={mobileSlider}
          {...(productCardSettings && { options: productCardSettings })}
        />
      )}
    </div>
  ))

  const renderGridItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {result ? (
        <CardComponent
          result={result}
          className="wk-wishlist-button-target"
          dataIndex={id.toString()}
          mobileSlider={mobileSlider}
          {...(productCardSettings && { options: productCardSettings })}
        />
      ) : (
        <SkeletonComponent {...(productCardSettings && { options: productCardSettings })} />
      )}
    </div>
  ))

  return (
    <div ref={setNode} className={clsx(containerClassName, wrapperClassName)}>
      {renderWrapper ? renderWrapper(renderSkeletonItems(), renderRealItems()) : renderGridItems()}
    </div>
  )
}
